// extracted by mini-css-extract-plugin
module.exports = {"tableDiv":"tableDiv--2sI5zFxq"};